import { render, staticRenderFns } from "./expressOrderSend.vue?vue&type=template&id=221ca266&scoped=true"
import script from "./expressOrderSend.vue?vue&type=script&lang=js"
export * from "./expressOrderSend.vue?vue&type=script&lang=js"
import style0 from "./expressOrderSend.vue?vue&type=style&index=0&id=221ca266&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ca266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221ca266')) {
      api.createRecord('221ca266', component.options)
    } else {
      api.reload('221ca266', component.options)
    }
    module.hot.accept("./expressOrderSend.vue?vue&type=template&id=221ca266&scoped=true", function () {
      api.rerender('221ca266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/expressOrderList/components/expressOrderSend.vue"
export default component.exports